export const DOMONDA_RESULT_SUCCESS_STATUS = 'SUCCESS'

export const DOMONDA_STATUS_PENDING = 'PENDING'

export const DOMONDA_STATUS_STARTED = 'STARTED'

export const DOMONDA_PENDING_STATUSES = [
  DOMONDA_STATUS_PENDING,
  DOMONDA_STATUS_STARTED,
]

export const DOMONDA_POLL_INTERVAL_MS = 1000

export const DOMONDA_POLL_MAX_ATTEMPTS = 30

export const DOMONDA_POLL_FIRST_ATTEMPT = 1

export const INVOICE_FIELD_TYPE_STR = 'str'

export const INVOICE_FIELD_TYPE_INT = 'int'

export const INVOICE_FIELD_TYPE_FLOAT = 'float'

export const INVOICE_FIELD_TYPE_DATE = 'date'

export const INVOICE_FIELD_TYPE_SELECT = 'select'

export const INVOICE_FIELD_TYPE_SUPPLIER = 'supplier'

export const INVOICE_FIELD_TYPE_READONLY = 'readonly'

export const INVOICE_FIELD_TYPE_BIC = 'bic'

export const INVOICE_FIELD_TYPE_IBAN = 'iban'

export const INVOICE_FIELD_NAME_NOTES = 'notes'

export const INVOICE_FIELD_NAME_SUPPLIER = 'supplier_id'

export const INVOICE_FIELD_LABEL_SUPPLIER = 'InvoiceSupplierLabel'

export const INVOICE_FIELD_NAME_RECIPIENT = 'recipient'

export const INVOICE_FIELD_LABEL_RECIPIENT = 'InvoiceRecipientLabel'

// The qa value predates the rename from DocumentMarkAsInvoice — kept as is to
// not break existing QA selectors.
export const QA_NAME_INVOICE_MODAL = 'documentMarkAsInvoice'

export const QA_NAME_INVOICE_MODAL_PARSE_BTN = 'parse'

export const QA_NAME_INVOICE_MODAL_UPLOAD_FILE_BTN = 'uploadInvoiceFile'

export const QA_NAME_INVOICE_MODAL_REPLACE_FILE_BTN = 'replaceInvoiceFile'

export const QA_NAME_INVOICE_MODAL_DELETE_FILE_BTN = 'deleteInvoiceFile'

export const QA_NAME_INVOICE_MODAL_DELETE_FILE_CONFIRM_MODAL =
  'deleteInvoiceFileConfirm'

export const INVOICE_MODAL_PARSING_ERROR_NOTIFICATION =
  'invoiceModalParsingError'

// "Payment receiver" / recipient arrives with empty validation but is capped at 128 chars.
export const INVOICE_MODAL_FIELD_RECIPIENT_MAX_LENGTH = 128

// BIC and IBAN use the standard banking limits (same as the building form).
export const INVOICE_MODAL_FIELD_BIC_MAX_LENGTH = 11

export const INVOICE_MODAL_FIELD_IBAN_MAX_LENGTH = 34

export const INVOICE_MODAL_FIELD_AMOUNT_MIN = 0

export const INVOICE_MODAL_FIELD_AMOUNT_FRACTION_DIGITS = 2
